import React from 'react';
import { formatBytes, formatBandwidthBytes } from '../../../utility/utility';

export default class DedicatedCpu extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            closeDedicated: false,
            isCpuOptimised: true,
            isMemoryOptimised: false,
            isStorageOptimised: false,
            isLocalClick: false
        };
    }

    onPlanClick = (event, param) => {
        this.props.planBoxClick(event, param);
    };
    onOptimisedClick = () => {
        this.props.setYearly();
    };
    render() {
        let cpuOptimisedList = [];
        let memoryOptimised = [];
        let storageOptimisedList = [];
        let isCpuOptimisedLoc = this.state.isCpuOptimised;
        let isMemoryOptimisedLoc = this.state.isMemoryOptimised;
        if(!this.state.isLocalClick && this.props.selectedFlavor && this.props.selectedFlavor.type) {
            isCpuOptimisedLoc = this.props.selectedFlavor.type === 'COF';
            isMemoryOptimisedLoc = !isCpuOptimisedLoc;

        }

        if(this.props.dcpuList && this.props.dcpuList.length > 0) {
            let dcpuList = this.props.dcpuList;
            for(let i = 0; i < dcpuList.length; i++) {
                let elem = dcpuList[i];
                if(elem.type === 'COF') {
                    cpuOptimisedList.push(elem);
                } else if(elem.type === 'DOF') {
                    storageOptimisedList.push(elem);
                } else if(elem.type === 'MOF') {
                    memoryOptimised.push(elem);
                }
            }
        }
        return (
            <React.Fragment>
                <div className="plan_dcpu" >

                    <div className="dcpu_message">
                    </div>

                    <div className="dcpu_tabs">

                        <div className="tw_tabs">
                            <ul className="d_flex">
                                <li className={ isCpuOptimisedLoc ? "active" : "" } data-tabs="CPU-Optimized" onClick={ () => { this.setState({ isStorageOptimised: false, isMemoryOptimised: false, isCpuOptimised: true, isLocalClick: true }); this.props.setYearly(); } }>
                                    <p className="text">CPU-Optimized</p>
                                </li>
                                <li className={ isMemoryOptimisedLoc ? "active" : "" } data-tabs="Memory-Optimized" onClick={ () => { this.setState({ isCpuOptimised: false, isMemoryOptimised: true, isStorageOptimised: false, isLocalClick: true }); this.props.setYearly(); } }>
                                    <p className="text">Memory-Optimized</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="plan_wrap transparent_layer_wrap">
                        <div className="plan_cpu_optimized" style={ { display: this.state.isCpuOptimised && cpuOptimisedList.length === 0 ? 'block' : 'none' } } >
                            <p className="noplan_info">No plans available at this time. Choose a different plan or region to proceed.</p>
                        </div>
                        <div className="plan_cpu_optimized" style={ { display: isCpuOptimisedLoc && cpuOptimisedList.length > 0 ? 'block' : 'none' } } >
                            <div className="plan_container">
                                <ul className="scpu_tabs">
                                    <li class={ this.props.isPrepaidMonthly ? "active" : "" } data-tabs="SCPU-prepaid-monthly" onClick={ () => this.props.onDiffPlanClick('prepaidMonthly') }>
                                        <p class="text">Prepaid Monthly</p>
                                    </li>
                                    <li data-tabs="SCPU-monthly" className={ this.props.isYearly || this.props.isPrepaidMonthly ? "" : "active" } onClick={ () => this.props.onDiffPlanClick('monthly') }><p className="text">Postpaid Monthly</p></li>
                                    <li className={ this.props.isYearly ? "active" : "" } data-tabs="SCPU-yearly" onClick={ () => this.props.onDiffPlanClick('yearly') }><p className="text">Prepaid Yearly</p></li>

                                </ul>
                                <div className={ this.props.isYearly ? "scpu_yearly_plan show" : "scpu_monthly_plan show" }>
                                    <div className="scpu_offerBlk no-bg">
                                        { this.props.isYearly ?
                                            <div className="offer-text-blk">
                                                <p className="saveoffer-txt">Save <span className="red-hht-txt">{ this.props.discPerce }%<sup>*</sup></span> on first year</p>
                                                <p className="subscribe-txt">Subscribe to prepaid yearly plans and get discounts</p>
                                            </div> :
                                            this.props.isPrepaidMonthly ?
                                                <div className="offer-text-blk">
                                                    <p className="saveoffer-txt">Save <span className="red-hht-txt">{ this.props.discMonPerce }%<sup>*</sup></span> on first year</p>
                                                    <p className="subscribe-txt">Subscribe to prepaid monthly plans and get discounts</p>
                                                </div> :
                                                <div className="offer-text-blk">
                                                    <p className="monthly-paytxt">Pay as you use with monthly postpaid plans</p>
                                                </div>
                                        }
                                    </div>
                                    {
                                        cpuOptimisedList.map((instancePlan, i) =>
                                            <div className={ instancePlan.isSelected ? "plan_box active" : "plan_box" } key={ i } onClick={ (e) => this.onPlanClick(e, instancePlan) }>

                                                { this.props.isYearly ?
                                                    <div className="cost_details">
                                                        <div className="cost_option2 actual_cost">
                                                            <span className="strike_thru">$ { instancePlan.monthlyRate * 12 }</span><span className="cost-sub">/year</span>
                                                        </div>
                                                        <div className="cost_option1">$ { instancePlan.monthlyRate * 12 - (instancePlan.monthlyRate * 12) / this.props.discVal }<span className="cost-sub">/first year</span></div>

                                                    </div> :
                                                    this.props.isPrepaidMonthly ?
                                                        <div className="cost_details">
                                                            <div className="cost_option2 actual_cost">
                                                                <span className="strike_thru">$ { instancePlan.monthlyRate }</span><span className="cost-sub">/month</span>
                                                            </div>
                                                            <div className="cost_option1">$ { instancePlan.monthlyRate - (instancePlan.monthlyRate) / this.props.discMonVal }<span className="cost-sub">/month</span></div>
                                                        </div>
                                                        :
                                                        <div className="cost_details">

                                                            <div className="cost_option1">$ { instancePlan.monthlyRate }<span className="cost-sub">/month</span>
                                                            </div>
                                                            <div className="cost_option2">${ instancePlan.hourlyRate }/hour</div>
                                                        </div>
                                                }
                                                <div className="plan_details">
                                                    <ul className="detail_info">
                                                        <li>
                                                            <div className="col1">RAM</div>
                                                            <div className="col2">{ instancePlan.ram }</div>
                                                        </li>
                                                        <li>
                                                            <div className="col1">Processor</div>
                                                            <div className="col2">{ instancePlan.processor }</div>
                                                        </li>
                                                        <li>
                                                            <div className="col1">NVMe Storage</div>
                                                            <div className="col2">{ instancePlan.storage }</div>
                                                        </li>
                                                        <li>
                                                            <div className="col1">Bandwidth</div>
                                                            <div className="col2">{ formatBandwidthBytes(instancePlan.bandwidth, this.props.isYearly) }</div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        )
                                    }
                                    { this.props.isYearly && <p className="offer_note">
                                        <span className="offer_note_star">*</span><span className="offer_note_info">Note</span>:
                                        <br></br>- The { this.props.discPerce }% offer is applicable for the first year only. For subsequent years, normal charges are applicable.
                                        <br></br>- Any charges incurred for the instance will not be refunded on deleting the instance.
                                        <br></br>- The bandwidth limit specified under the Virtual Server yearly plans is the monthly cut-off.
                                    </p> }
                                    { this.props.isPrepaidMonthly && <p className="offer_note">
                                        <span className="offer_note_star">*</span><span className="offer_note_info">Note</span>:
                                        <br></br>- The { this.props.discMonPerce }% offer is applicable for the first year only. For subsequent years, normal charges are applicable.
                                        <br></br>- Any charges incurred for the instance will not be refunded on deleting the instance.
                                        <br></br>- The bandwidth limit specified under the Virtual Server yearly plans is the monthly cut-off.
                                    </p> }
                                </div>
                            </div>

                        </div>
                        <div className="plan_memory_optimized" style={ { display: this.state.isMemoryOptimised && memoryOptimised.length === 0 ? 'block' : 'none' } } >
                            <p className="noplan_info">No plans available at this time. Choose a different plan or region to proceed.</p>
                        </div>
                        <div className="plan_memory_optimized" style={ { display: isMemoryOptimisedLoc && memoryOptimised.length > 0 ? 'block' : 'none' } } >
                            <div className="plan_container">
                                <ul className="scpu_tabs">
                                    <li class={ this.props.isPrepaidMonthly ? "active" : "" } data-tabs="SCPU-prepaid-monthly" onClick={ () => this.props.onDiffPlanClick('prepaidMonthly') }>
                                        <p class="text">Prepaid Monthly</p>
                                    </li>
                                    <li data-tabs="SCPU-monthly" className={ this.props.isYearly || this.props.isPrepaidMonthly ? "" : "active" } onClick={ () => this.props.onDiffPlanClick('monthly') }><p className="text">Postpaid Monthly</p></li>
                                    <li className={ this.props.isYearly ? "active" : "" } data-tabs="SCPU-yearly" onClick={ () => this.props.onDiffPlanClick('yearly') }><p className="text">Prepaid Yearly</p></li>

                                </ul>
                                <div className={ this.props.isYearly ? "scpu_yearly_plan show" : "scpu_monthly_plan show" }>
                                    <div className="scpu_offerBlk no-bg">
                                        { this.props.isYearly ?
                                            <div className="offer-text-blk">
                                                <p className="saveoffer-txt">Save <span className="red-hht-txt">{ this.props.discPerce }%<sup>*</sup></span> on first year</p>
                                                <p className="subscribe-txt">Subscribe to prepaid yearly plans and get discounts</p>
                                            </div> :
                                            this.props.isPrepaidMonthly ?
                                                <div className="offer-text-blk">
                                                    <p className="saveoffer-txt">Save <span className="red-hht-txt">{ this.props.discMonPerce }%<sup>*</sup></span> on first year</p>
                                                    <p className="subscribe-txt">Subscribe to prepaid monthly plans and get discounts</p>
                                                </div> :
                                                <div className="offer-text-blk">
                                                    <p className="monthly-paytxt">Pay as you use with monthly postpaid plans</p>
                                                </div>
                                        }
                                    </div>
                                    {
                                        memoryOptimised.map((instancePlan, i) =>
                                            <div className={ instancePlan.isSelected ? "plan_box active" : "plan_box" } key={ i } onClick={ (e) => this.onPlanClick(e, instancePlan) }>

                                                { this.props.isYearly ?
                                                    <div className="cost_details">
                                                        <div className="cost_option2 actual_cost">
                                                            <span className="strike_thru">$ { instancePlan.monthlyRate * 12 }</span><span className="cost-sub">/year</span>
                                                        </div>
                                                        <div className="cost_option1">$ { instancePlan.monthlyRate * 12 - (instancePlan.monthlyRate * 12) / this.props.discVal }<span className="cost-sub">/first year</span></div>
                                                    </div> :
                                                    this.props.isPrepaidMonthly ?
                                                        <div className="cost_details">
                                                            <div className="cost_option2 actual_cost">
                                                                <span className="strike_thru">$ { instancePlan.monthlyRate }</span><span className="cost-sub">/month</span>
                                                            </div>
                                                            <div className="cost_option1">$ { instancePlan.monthlyRate - (instancePlan.monthlyRate) / this.props.discMonVal }<span className="cost-sub">/month</span></div>
                                                        </div>
                                                        :
                                                        <div className="cost_details">

                                                            <div className="cost_option1">$ { instancePlan.monthlyRate }<span className="cost-sub">/month</span>
                                                            </div>
                                                            <div className="cost_option2">${ instancePlan.hourlyRate }/hour</div>
                                                        </div>
                                                }

                                                <div className="plan_details">
                                                    <ul className="detail_info">
                                                        <li>
                                                            <div className="col1">RAM</div>
                                                            <div className="col2">{ instancePlan.ram }</div>
                                                        </li>
                                                        <li>
                                                            <div className="col1">Processor</div>
                                                            <div className="col2">{ instancePlan.processor }</div>
                                                        </li>
                                                        <li>
                                                            <div className="col1">NVMe Storage</div>
                                                            <div className="col2">{ instancePlan.storage }</div>
                                                        </li>
                                                        <li>
                                                            <div className="col1">Bandwidth</div>
                                                            <div className="col2">{ formatBandwidthBytes(instancePlan.bandwidth, this.props.isYearly) }</div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        )
                                    }
                                    { this.props.isYearly && <p className="offer_note">
                                        <span className="offer_note_star">*</span><span className="offer_note_info">Note</span>:
                                        <br></br>- The { this.props.discPerce }% offer is applicable for the first year only. For subsequent years, normal charges are applicable.
                                        <br></br>- Any charges incurred for the instance will not be refunded on deleting the instance.
                                        <br></br>- The bandwidth limit specified under the Virtual Server yearly plans is the monthly cut-off.
                                    </p> }
                                    { this.props.isPrepaidMonthly && <p className="offer_note">
                                        <span className="offer_note_star">*</span><span className="offer_note_info">Note</span>:
                                        <br></br>- The { this.props.discMonPerce }% offer is applicable for the first year only. For subsequent years, normal charges are applicable.
                                        <br></br>- Any charges incurred for the instance will not be refunded on deleting the instance.
                                        <br></br>- The bandwidth limit specified under the Virtual Server yearly plans is the monthly cut-off.
                                    </p> }
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </React.Fragment>
        );
    }
}